import { useState } from 'react';
import type { Product } from '../../../types/product';

interface ProductTabsProps {
  product: Product;
}

export default function ProductTabs({ product }: ProductTabsProps) {
  const [activeTab, setActiveTab] = useState<'description' | 'ingredients' | 'howToUse'>('description');

  return (
    <div className="mb-12 sm:mb-20">
      {/* Tab Headers */}
      <div className="flex items-center gap-0 sm:gap-2 border-b border-gray-200 mb-6 sm:mb-8 overflow-x-auto">
        <button
          onClick={() => setActiveTab('description')}
          className={`px-3 sm:px-6 py-3 text-xs sm:text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
            activeTab === 'description'
              ? 'text-[#2E7D32] border-b-2 border-[#2E7D32]'
              : 'text-gray-500 hover:text-gray-900'
          }`}
        >
          DESCRIPTION
        </button>
        <button
          onClick={() => setActiveTab('ingredients')}
          className={`px-3 sm:px-6 py-3 text-xs sm:text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
            activeTab === 'ingredients'
              ? 'text-[#2E7D32] border-b-2 border-[#2E7D32]'
              : 'text-gray-500 hover:text-gray-900'
          }`}
        >
          INGREDIENTS
        </button>
        <button
          onClick={() => setActiveTab('howToUse')}
          className={`px-3 sm:px-6 py-3 text-xs sm:text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
            activeTab === 'howToUse'
              ? 'text-[#2E7D32] border-b-2 border-[#2E7D32]'
              : 'text-gray-500 hover:text-gray-900'
          }`}
        >
          HOW TO USE
        </button>
      </div>

      {/* Tab Content */}
      <div className="prose max-w-none">
        {activeTab === 'description' && (
          <div className="text-sm text-gray-600 leading-relaxed">
            <p>{product.long_description}</p>
          </div>
        )}

        {activeTab === 'ingredients' && (
          <div className="text-sm text-gray-600 leading-relaxed">
            <p>{product.ingredients}</p>
          </div>
        )}

        {activeTab === 'howToUse' && (
          <div className="text-sm text-gray-600 leading-relaxed">
            <p>{product.how_to_use}</p>
          </div>
        )}
      </div>
    </div>
  );
}
